(function () {
  var STORAGE_KEY = 'layur_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    saveWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (h) {
      return h !== handle;
    });
    saveWishlist(list);
  }

  function updateHeartButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      var wrapper = el.closest('[data-wishlist-count-wrapper]');
      if (wrapper) {
        if (list.length > 0) {
          wrapper.removeAttribute('hidden');
        } else {
          wrapper.setAttribute('hidden', 'hidden');
        }
      }
    });
  }

  function formatMoney(cents) {
    try {
      var amount = cents / 100;
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return amount.toLocaleString('nl-NL', { style: 'currency', currency: currency });
    } catch (e) {
      return '';
    }
  }

  function renderWishlistDrawer() {
    var container = document.getElementById('WishlistDrawerItems');
    var emptyMsg = document.getElementById('WishlistDrawerEmpty');
    if (!container) return;

    var list = getWishlist();
    container.innerHTML = '';

    if (list.length === 0) {
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }
    if (emptyMsg) emptyMsg.style.display = 'none';

    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          var currentList = getWishlist();
          if (currentList.indexOf(handle) === -1) return;

          var item = document.createElement('div');
          item.className = 'wishlist-drawer__item';
          item.setAttribute('data-wishlist-item', handle);

          var imageUrl = product.featured_image || (product.images && product.images[0]) || '';

          var imageLink = document.createElement('a');
          imageLink.href = product.url;
          imageLink.className = 'wishlist-drawer__item-image';
          var img = document.createElement('img');
          img.src = imageUrl;
          img.alt = product.title;
          img.loading = 'lazy';
          img.width = 72;
          img.height = 72;
          imageLink.appendChild(img);

          var info = document.createElement('div');
          info.className = 'wishlist-drawer__item-info';
          var titleLink = document.createElement('a');
          titleLink.href = product.url;
          titleLink.className = 'wishlist-drawer__item-title';
          titleLink.textContent = product.title;
          var price = document.createElement('div');
          price.className = 'wishlist-drawer__item-price';
          price.textContent = formatMoney(product.price);
          info.appendChild(titleLink);
          info.appendChild(price);

          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'wishlist-drawer__item-remove';
          removeBtn.setAttribute('aria-label', 'Verwijderen uit wishlist');
          removeBtn.setAttribute('data-wishlist-toggle', handle);
          removeBtn.innerHTML = '&times;';

          item.appendChild(imageLink);
          item.appendChild(info);
          item.appendChild(removeBtn);
          container.appendChild(item);
        })
        .catch(function () {});
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    var overlay = document.getElementById('WishlistDrawerOverlay');
    if (!drawer) return;
    renderWishlistDrawer();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    var overlay = document.getElementById('WishlistDrawerOverlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(toggleBtn.getAttribute('data-wishlist-toggle'));
      return;
    }

    var openBtn = e.target.closest('[data-wishlist-drawer-toggle]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var closeBtn = e.target.closest('[data-wishlist-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('wishlist:updated', function () {
    updateHeartButtons();
    var drawer = document.getElementById('WishlistDrawer');
    if (drawer && drawer.classList.contains('is-open')) {
      renderWishlistDrawer();
    }
  });

  function init() {
    updateHeartButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Wishlist = {
    get: getWishlist,
    toggle: toggleWishlist,
    remove: removeFromWishlist,
    has: isInWishlist
  };
})();
